import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Mission } from '../../data-management.model';
import { DataManagementService } from '../../data-management.service';
import { MissionService } from '../../providers';
import { rapportsDir } from '../../../../global.config';
import * as XLSX from 'xlsx';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-mission-form',
  templateUrl: './mission-form.component.html',
  styleUrls: ['./mission-form.component.scss']
})
export class MissionFormComponent implements OnInit {
  @Output()
  missionSaved: EventEmitter<Mission> = new EventEmitter<Mission>();

  loading: boolean = false;
  mission: Mission = new Mission();
  @Input() mode = 'ADD';
  searchText: any;

  @Input()
  set mission_(mission: Mission) {
    this.selectedPoi = [];
    this.mission = Object.assign({}, mission);
    if (this.mission) {
      let index = 0;
      for (let poi of this.mission.routeLegs) {
        if (index == 0) {
          this.selectedPoi.push({
            id: poi.idPOISource,
            name: poi.labelPOISource
          });
        }
        this.selectedPoi.push({
          id: poi.idPOITarget,
          name: poi.labelPOITarget
        });
        index++;
      }
    }
  }

  items: { id: number, name: string }[] = [];
  selectedItems: { id: number, name: string }[] = [];
  selectedPoi: { id: number, name: string }[] = [];
  found = false;

  template: string = 'Mission-Pois.xlsx';
  templateDownloadLocation: string = rapportsDir;
  selectedFile: File = null;
  importedPois: { code: any; name: any }[];
  headers = ['Code', 'Nom'];
  messageError = '';
  @ViewChild('importModal', { static: false }) importModal!: ModalDirective;

  constructor(
    private toastr: ToastrService,
    private dataManagementService: DataManagementService,
    private missionService: MissionService
  ) {}

  ngOnInit() {
    this.loadPOI();
  }

  // Move row up
  moveRowUp(index: number) {
    if (index > 0) {
      const temp = this.selectedPoi[index];
      this.selectedPoi[index] = this.selectedPoi[index - 1];
      this.selectedPoi[index - 1] = temp;
      this.onDropSuccess(this.selectedPoi); // Validate after moving
    }
  }

  // Move row down
  moveRowDown(index: number) {
    if (index < this.selectedPoi.length - 1) {
      const temp = this.selectedPoi[index];
      this.selectedPoi[index] = this.selectedPoi[index + 1];
      this.selectedPoi[index + 1] = temp;
      this.onDropSuccess(this.selectedPoi); // Validate after moving
    }
  }

  loadPOI() {
    this.loading = true;
    this.dataManagementService.getAllPointInterestsByType('MARKER')
      .subscribe(pointInterests => {
        this.loading = false;
        pointInterests.forEach(p => {
          this.items.push({ id: p.idPointInterest, name: p.name });
        });
      }, err => {
        this.loading = false;
        this.toastr.error("Erreur lors de chargement", "Point interest");
      });
  }

  resetMission() {
    this.mission = new Mission();
    this.selectedPoi = [];
  }

  onSaveMission() {
    this.loading = true;
    this.mission.pointOfInterests = this.selectedPoi.map(item => item.id);
    this.missionService.add(this.mission)
      .subscribe(mission => {
        this.missionSaved.emit(mission);
        this.mission = new Mission();
        this.loading = false;
        this.toastr.success("Enregistré", "Mission");
      }, err => {
        this.loading = false;
        this.toastr.error("Erreur lors d'ajout", "Mission");
      });
  }

  onUpdateMission() {
    this.loading = true;
    this.mission.pointOfInterests = this.selectedPoi.map(item => item.id);
    this.missionService.update(this.mission)
      .subscribe(mission => {
        this.missionSaved.emit(mission);
        this.mission = new Mission();
        this.loading = false;
        this.toastr.success("Modifié", "Mission");
      }, err => {
        this.loading = false;
        this.toastr.error("Erreur lors la modification", "Mission");
      });
  }

  onDropSuccess(itemId: any) {
    this.found = false;
    for (let j = 0; j < itemId.length; j++) {
      if (j > 0 && itemId[j].id == itemId[j - 1].id) {
        this.found = true;
        this.toastr.warning("Veuillez verifier le P.O.I précédent !!", "Mission");
        break;
      }
    }
  }

  onDelete(selectedPoi: any, i: any) {
    this.found = false;
    selectedPoi.splice(i, 1);
    for (let j = 0; j < selectedPoi.length; j++) {
      if (j > 0 && selectedPoi[j].id == selectedPoi[j - 1].id) {
        this.found = true;
        this.toastr.warning("Veuillez verifier le P.O.I précédent !!", "Mission");
        break;
      }
    }
  }

  onChange(event: any) {
    this.selectedItems = this.items.filter(item => item.id == event);
    if (this.selectedPoi.length > 0) {
      if (event == this.selectedPoi[this.selectedPoi.length - 1].id) {
        this.toastr.warning("Veuillez verifier le P.O.I précédent !!", "Mission");
        return;
      }
    }
    for (let i = 0; i < this.selectedItems.length; i++) {
      this.selectedPoi.push({
        id: this.selectedItems[i].id,
        name: this.selectedItems[i].name
      });
    }
  }

  onFileChanged(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];
      this.readExcelFile(this.selectedFile);
    }
  }

  readExcelFile(blob: Blob): void {
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      const binaryData: string = e.target.result;
      const workbook: XLSX.WorkBook = XLSX.read(binaryData, { type: 'binary' });
      const sheetName: string = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const data: any[] = XLSX.utils.sheet_to_json(sheet, { range: 3 });
      console.log(data);
      if (data.length !== 0) {
        const keys1 = Object.keys(data[0]).sort();
        if (JSON.stringify(keys1) === JSON.stringify(this.headers.sort())) {
          this.importedPois = data.map(item => ({
            code: item['Code'],
            name: item['Nom'],
          }));
          this.messageError = '';
        } else {
          this.messageError = 'Incompatible template';
        }
      } else {
        this.messageError = 'fichier excel est vide.';
      }
    };
    reader.readAsBinaryString(blob);
  }

  onUpload() {
    const notExist: any[] = [];
    this.importedPois.map(poi => {
      let poiToAdd = this.items.find(item => item.name === poi.code);
      if (!poiToAdd) {
        poiToAdd = this.items.find(item => item.name === poi.name);
      }
      if (poiToAdd) {
        this.selectedPoi.push({
          id: poiToAdd.id,
          name: poiToAdd.name,
        });
      } else {
        if (!notExist.find(item => item.name === poi.name || item.code === poi.code)) {
          notExist.push(poi);
        }
      }
    });
    notExist?.map(poi => {
      this.toastr.warning(`POI ${poi.name} (${poi.code}) n'existe pas.`, 'Mission');
    });
    this.selectedFile = null;
    this.closeImportModal();
  }

  closeImportModal() {
    this.importModal.hide();
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.selectedPoi, event.previousIndex, event.currentIndex);
  }
}
